import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useArchivedRmasByDevice } from '../hooks/useArchivedRmas';
import ArchivedRmaList from './ArchivedRmaList.jsx';
import { colors } from '../theme';

export default function DeviceArchivePanel({
  deviceId,
  serialNumber,
  isServiceUser,
  isVisible,
  onRefetchRef
}) {
  const normalizedDeviceId = deviceId ? String(deviceId) : '';
  const normalizedSerial = serialNumber ? String(serialNumber) : '';
  const shouldFetch = Boolean(isVisible && (normalizedSerial || normalizedDeviceId));

  const {
    items,
    isLoading,
    error,
    refetch
  } = useArchivedRmasByDevice({
    deviceId: normalizedDeviceId,
    serialNumber: normalizedSerial,
    enabled: shouldFetch
  });

  useEffect(() => {
    if (!shouldFetch) return;
    if (typeof onRefetchRef === 'function') {
      onRefetchRef(() => refetch());
    }
  }, [refetch, onRefetchRef, shouldFetch]);

  if (!isVisible) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem' }}>
        <h2 style={{ margin: 0, color: colors.textStrong, fontFamily: "'Barlow Condensed', 'Barlow', sans-serif", fontSize: '2rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Archived RMAs</h2>
        {isServiceUser && (
          <a
            href="/rma-archive"
            style={{
              color: colors.accent,
              textDecoration: 'none',
              fontWeight: 600
            }}
          >
            See all archived RMAs
          </a>
        )}
      </div>

      <ArchivedRmaList
        items={items}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        emptyMessage="No archived RMAs for this device."
      />
    </div>
  );
}

DeviceArchivePanel.propTypes = {
  deviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serialNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isServiceUser: PropTypes.bool,
  isVisible: PropTypes.bool,
  onRefetchRef: PropTypes.func
};
